<template>
  <div class="myValues">
    <p class="myValues_p">{{ myValues.slice(0, isOpen ? myValues.length : min-1).join('\n') }}</p>
    <i v-if="!isOpen && myValues.length > (min-1)" class="el-icon-more myValues_icon" />
    <i
      v-if="myValues.length > (min-1)"
      class="myValues_open"
      :class="{
        'el-icon-caret-right': !isOpen,
        'el-icon-caret-bottom': isOpen
      }"
      @click="isOpen = !isOpen"
    />
  </div>
</template>

<script>
export default {
  props: {
    myValues: {
      type: Array,
      default() {
        return []
      }
    },
    min: {
      type: [Number, String],
      default: 4
    }
  },
  data() {
    return {
      isOpen: false // 控制是否展开
    }
  }
}
</script>

<style scoped>
.myValues{
   position: relative;
   padding-right: 17px;
}

.myValues_p{
   white-space: break-spaces;
}

.myValues_icon{
  font-size: 24px;
}

.myValues_open{
  position: absolute;
  cursor: pointer;
  top: 1px;
  right: -7px;
  font-size: 24px;
}
</style>
